<template>
    <div>
      <van-nav-bar
        title="推广账户"
        left-text=""
        left-arrow
        @click-left="$router.push('/member/members')"

      />
      <van-cell-group>
        <van-cell title="佣金余额" :value="agent_account" @click="$router.push({ name: 'AgentDepot', params: { tab: 0 } })" is-link>
        </van-cell>
        <!-- <van-cell title="提现" :value="wit_total" @click="$router.push({ name: 'AgentDepot', params: { tab: 1 } })" is-link/>
        <van-cell title="管理费" :value="manage_total" @click="$router.push({ name: 'AgentDepot', params: { tab: 2 } })" is-link/>
        <van-cell title="递延费总额" :value="deferred_total" @click="$router.push({ name: 'AgentDepot', params: { tab: 3 } })" is-link />
        <van-cell title="利润分成" :value="divide_total" @click="$router.push({ name: 'AgentDepot', params: { tab: 4 } })" is-link/>
        <van-cell title="会员管理奖" :value="push_total" @click="$router.push({ name: 'AgentDepot', params: { tab: 5 } })" is-link/> -->
        <van-cell title="资金提现划转" is-link to="agency/agent_transfer_withdrawal"/>
        <!-- <van-cell title="资金提现" is-link to="agency/agency_withdrawal"/> -->
        <!-- <van-cell title="资金划转" is-link to="agency/agency_transfer"/> -->
        <van-cell title="推广链接" is-link to="agency/agency_link"/>
        <van-cell title="我的团队" is-link to="agency/my_team"/>
        <!-- <van-cell title="下级持仓人数" is-link to="agency/lower_lever_depot"/> -->
      </van-cell-group>
    </div>
</template>

<script>
    export default {
      name: "Agency",
      data(){
        return{
          agent_account:'',
          manage_total:0,
          divide_total:0,
          deferred_total:0,
          push_total:0,
          wit_total:0,

        }
      },
      computed:{
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        getUser() {
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "user",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code === 1) {
                that.agent_account = resData.data.agent_account;
              } else if (res.data.code === 0 || res.data.code === -1) {
                that.$toast.fail(resData.msg);
              }
            });
        },
        getAgentAccount(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_account",
                token: sessionStorage.getItem("token"),
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.deferred_total = resData.data.deferred_total;
                that.divide_total = resData.data.divide_total;
                that.manage_total = resData.data.manage_total;
                that.wit_total = resData.data.wit_total;
                that.push_total = resData.data.push_total;
              }else if (res.data.code == 0) {
                that.$toast.fail(res.data.msg);
              }
            });
        },

      },
      mounted:function () {
        this.isLogin();
        this.getUser();
        this.getAgentAccount();
      }
    }
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Agency.vue